import './LadderPopover.scss'
import { IonButton } from '@ionic/react'
import React, { useEffect, useState } from 'react'
import { connectLadderPopover } from './LadderPopover.connect'
import { createPortal } from 'react-dom'

const modalRoot = document.querySelector('#modal-root')

const LadderPopover = ({
  open,
  ladderTitle,
  ladderId,
  ladderData,
  actions,
  activeTab,
}) => {
  const [fancyPositionData, setFancyPositionData] = useState([])

  const isActive =
    [0, 1, 2, 3].includes(Number(activeTab)) || activeTab === 'All'

  const handleClose = () => {
    actions.setSportLadderShow(false)
  }

  useEffect(() => {
    const data = ladderData['fancy_position']
    if (data && data.length > 0) {
      const parsedData = []

      for (let i = 0; i < data.length; i++) {
        const item = data[i]

        if (item.key === '0' || item.key === 0) {
          parsedData[0] = item
        } else {
          if (i === 0) {
            const [_, val] = item.key.split('-')
            const base = parseInt(val)

            base &&
              (parsedData[0] = {
                key: base - 1,
                value: item.value,
                valueFull: item.valueFull,
              })
            parsedData[1] = {
              key: base || 1,
              value: item.value,
              valueFull: item.valueFull,
            }
          } else if (i > 0 && i < data.length - 1) {
            if (item.key.includes('-')) {
              const [start, end] = item.key.split('-').map(Number)
              for (let j = start; j <= end; j++) {
                parsedData.push({
                  key: j,
                  value: item.value,
                  valueFull: item.valueFull,
                })
              }
            } else {
              parsedData.push({
                key: parseInt(item.key),
                value: item.value,
                valueFull: item.valueFull,
              })
            }
          } else {
            if (item.key.includes('+')) {
              const [base] = item.key.split('+').map(Number)

              parsedData.push({
                key: base,
                value: item.value,
                valueFull: item.valueFull,
              })

              if (data[0].key !== '0') {
                parsedData.push({
                  key: base + 1,
                  value: item.value,
                  valueFull: item.valueFull,
                })
              }
            } else {
              const base = parseInt(item.key)
              parsedData.push({
                key: base,
                value: item.value,
                valueFull: item.valueFull,
              })
              parsedData.push({
                key: base + 1,
                value: item.value,
                valueFull: item.valueFull,
              })
            }
          }
        }
      }

      setFancyPositionData(parsedData)
    }
  }, [ladderData])

  const renderRows = (items) =>
    items?.map((item, index) => (
      <div className="LadderPopover__content__row" key={index}>
        <div className="LadderPopover__content__row__item LadderPopover__content__row__value">
          {item.key}
        </div>
        <div
          className={`LadderPopover__content__row__item LadderPopover__content__row__value ${
            item.value > 0 ? 'positive' : 'negative'
          }`}
        >
          {item.value}
        </div>
      </div>
    ))

  return createPortal(
    open && (
      <div
        className="LadderPopover-wrapper"
        onClick={(e) => e.currentTarget === e.target && handleClose()}
      >
        <div className="LadderPopover-wrapper-content">
          <div className="LadderPopover__title">{ladderTitle} - Ladder</div>

          <div
            className="LadderPopover__content"
            style={{ maxHeight: '80vh', overflow: 'scroll' }}
          >
            <div className="LadderPopover__content__row">
              <div className="LadderPopover__content__row__item">Runs</div>
              <div className="LadderPopover__content__row__item">P&L</div>
            </div>

            {!isActive
              ? renderRows(ladderData?.fancy_position || [])
              : renderRows(fancyPositionData)}
          </div>

          <IonButton onClick={handleClose} mode="md" class="LadderPopover__btn">
            OK
          </IonButton>
        </div>
      </div>
    ),
    modalRoot
  )
}

export default connectLadderPopover()(LadderPopover)
